import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import '@/plugins/jsoneditor'
import '@/plugins/registerServiceWorker'

Vue.config.productionTip = false

declare global {
  interface Window {
    app: Vue
  }
}

async function inititalize () {
  const app = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  })

  app.$vuetify.theme.dark = true

  app.$mount('#app')

  app.$store.dispatch('initialize')

  window.app = app
}

inititalize()
